/* eslint-disable import/no-anonymous-default-export */

const colours = {
	white: "#ffffff",
	offWhite: "#F5F5F5",

	// selective colors
	accent: "pink",
};

const gradients = {
	default: `linear(to-r, ${colours.accent}.400, ${colours.accent}.500)`,
};

const theme = { colours, gradients };

export default theme;
